import { setCookie } from "../cookie/setCookie";
export const ACCESS_TOKEN_KEY = "AccessToken";
export const REFRESH_COOKIE_KEY = "Authorization";
export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}
export function setAccessToken(token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
}
export function clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
}
// 쿠키에 저장하기
export function setRefreshToken(token) {
    setCookie(REFRESH_COOKIE_KEY, token);
}
// 쿠키에서 삭제하기
export function clearRefreshToken() {
    document.cookie = `${REFRESH_COOKIE_KEY}=; path=/; max-age=0`;
}
/**
 * document.cookie에서 특정 키를 찾아 반환
 * ex) "Authorization=Bearer%20xxx.yyy.zzz" 또는 "Authorization=xxx.yyy.zzz"
 */
export function getRefreshTokenFromCookie() {
    if (typeof document === "undefined")
        return null;
    const match = document.cookie
        .split(";")
        .map((v) => v.trim())
        .find((v) => v.startsWith(`${REFRESH_COOKIE_KEY}=`));
    if (!match)
        return null;
    const raw = decodeURIComponent(match.split("=")[1] ?? "");
    return raw || null;
}
/** Authorization 헤더에 넣을 문자열을 정규화 (Bearer 접두어 보정) */
export function toBearer(token) {
    return token.toLowerCase().startsWith("bearer ") ? token : `Bearer ${token}`;
}
